<div class="tw-flex tw-rounded-tl-[10px]">
    <span class="tw-mt-[20px] tw-ml-[30px] tw-mr-7" (click)="closeSidenav()"><mat-icon>close</mat-icon></span>
    <h4 translate>{{'CASHREGISTER.TOPBAR.SETTINGS.TITLE'}}</h4>
</div>
<div class="tw-flex" >
    <div class="mat-typography tw-w-full" class="custom-content tw-h-full tw-overflow-y-auto tw-w-[96%]">
        <tilby-magic-form [form]="cashregisterTopbarSettingsForm" class="tw-w-full tw-overflow-y-auto calc-real-height"></tilby-magic-form>
    </div>
</div>
